<app-header></app-header>
<div class="app-body">
  <app-sidebar></app-sidebar>
  
  <main class="main">
    <toaster-container [toasterconfig]="toasterconfig"></toaster-container>
    <ol class="breadcrumb">
      <!-- needed for spacing -->
    </ol>
    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div><!-- /.conainer-fluid -->
  </main>
</div>
<app-footer></app-footer>


// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/containers/admin-layout/admin-layout.component.html